import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { CommonGroupTag, SingletonInstanceId } from '../constants/services.esm.js';
import { LayoutType } from '../types/layouts.esm.js';
import { layoutToEntityValue } from './utilities/layout-to-entity.esm.js';

var saveLayout = function saveLayout(serviceNamespace, setUserEntity) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(layout) {
      var value, _value;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!layout.selected) {
              _context.next = 6;
              break;
            }
            value = layoutToEntityValue(layout);
            _context.next = 4;
            return setUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.current, SingletonInstanceId, value);
          case 4:
            _context.next = 19;
            break;
          case 6:
            _context.t0 = layout.type;
            _context.next = _context.t0 === LayoutType.Default ? 9 : _context.t0 === LayoutType.Custom ? 10 : _context.t0 === LayoutType.Predefined ? 11 : _context.t0 === LayoutType.Saved ? 12 : 18;
            break;
          case 9:
            throw new Error('Cannot save a default layout that is not current');
          case 10:
            throw new Error('Cannot save a custom layout that is not current');
          case 11:
            throw new Error('Cannot save a custom layout that is not current');
          case 12:
            if (layout.id) {
              _context.next = 14;
              break;
            }
            throw new Error('Missing ID');
          case 14:
            _value = layoutToEntityValue(layout);
            _context.next = 17;
            return setUserEntity(serviceNamespace.entityTag, serviceNamespace.groupTag, CommonGroupTag.variation, layout.id, _value);
          case 17:
            return _context.abrupt("break", 19);
          case 18:
            throw new Error('Invalid type');
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

export { saveLayout };
//# sourceMappingURL=save-layout.esm.js.map
